import { keyBy } from "lodash";
import { feature as topoToGeo } from "topojson-client";
import { getData, getGrantsData, getSettingsData } from "../api";

const convertTopoIfNeeded = topologyObjectsName => json => {
    return topologyObjectsName
        ? topoToGeo(json, json.objects[topologyObjectsName])
        : json;
};
const toJSON = response => response.json();
const fetchJson = url => fetch(url).then(toJSON);

export const getGeoJSON = (url, topologyObjectsName) => {
    return dispatch => {
        dispatch({ type: "GEOJSON:REQUEST" });
        return fetchJson(url)
            .then(convertTopoIfNeeded(topologyObjectsName))
            .then(geojson => dispatch({ type: "GEOJSON:SUCCESS", payload: geojson }))
            .catch(error => dispatch({ type: "GEOJSON:FAILURE", payload: error }));
    };
};

export const getAllGrants = () => {
    return dispatch => {
        dispatch({ type: "GRANTS:ALL:REQUEST" });

        return getGrantsData()
            .then(data => {
                // Key by project
                const dataKeyBy = keyBy(data, "programName");
                dispatch({
                    type: "GRANTS:ALL:SUCCESS",
                    payload: dataKeyBy,
                });
            })
            .catch(err => {
                console.log(err);
                dispatch({ type: "GRANTS:ALL:ERROR", payload: err });
            });
    };
};

export const getSettings = () => {
    return dispatch => {
        dispatch({ type: "SETTINGS:ALL:REQUEST" });
        return getSettingsData()
            .then(data => {
                dispatch({
                    type: "SETTINGS:ALL:SUCCESS",
                    payload: data,
                });
            })
            .catch(err => {
                console.log(err);
                dispatch({ type: "SETTINGS:ALL:ERROR", payload: err });
            });
    };
};

export const getAllProjects = () => {
    return dispatch => {
        dispatch({ type: "PROJECT:ALL:REQUEST" });

        return (
            getData()
                // Group by fund
                .then(data => {
                    return data.reduce((acc, currProject) => {
                        const { Fund } = currProject;
                        if (acc[Fund]) {
                            return {
                                ...acc,
                                [Fund]: [...acc[Fund], currProject],
                            };
                        } else {
                            return {
                                ...acc,
                                [Fund]: [currProject],
                            };
                        }
                    }, {});
                })
                .then(dataForAllFund => {
                    dispatch({
                        type: "PROJECT:ALL:SUCCESS",
                        payload: dataForAllFund,
                    });
                })
                .catch(err => {
                    console.log(err);
                    dispatch({ type: "PROJECT:ALL:ERROR", payload: err });
                })
        );
    };
};



// WEBPACK FOOTER //
// ./src/actions/data.js